import { z } from "zod";
import {
  EDocumentKey,
  EDocumentList,
  EI9DocumentPhotoSide,
} from "@zeal/common";

const documentPhotoSchema = z.object({
  doc_url: z.string(),
  description: z.string().optional(),
  side: z.nativeEnum(EI9DocumentPhotoSide).optional(),
  file_suffix: z.number(),
});

const documentSchema = z.object({
  document_key: z.nativeEnum(EDocumentKey),
  document_list: z.nativeEnum(EDocumentList),
  document_photos: z.array(documentPhotoSchema).optional(),
  persona_inquiry_id: z.string().optional(),
});

export const postUploadI9DocumentRequestSchema = z.object({
  employeeID: z.string().min(1),
  document_type: z.nativeEnum(EDocumentKey),
  files: z.any(), // FormData files
});

export const postUploadI9DocumentResponseSchema = z.object({
  success: z.boolean(),
  data: z
    .object({
      document: documentSchema,
      i9OnboardingInfo: z.object({
        workerID: z.string(),
        companyID: z.string(),
        documents: z.array(documentSchema),
      }),
    })
    .optional(),
  error: z.string().optional(),
});

export type TPostUploadI9DocumentRequest = z.infer<
  typeof postUploadI9DocumentRequestSchema
>;
export type TPostUploadI9DocumentResponse = z.infer<
  typeof postUploadI9DocumentResponseSchema
>;
